<template>
  <div id="app">
    <canvas id="ora"></canvas>
    <span>Coming soon...</span>
  </div>
</template>

<script>
import { TweenMax, Power4 } from "gsap";
const LeonSans = require("leonsans");
let leons = [];
let canvas, ctx;
let trand = [
  Math.floor(Math.random() * (3000 - 1000) + 1000),
  Math.floor(Math.random() * (3000 - 1000) + 1000),
  Math.floor(Math.random() * (3000 - 1000) + 1000)
];
export default {
  name: "app",

  data() {
    return { sw: 400, sh: 300, pixelRatio: 2 };
  },
  mounted: function() {
    this.init();
  },
  methods: {
    init() {
      canvas = document.getElementById("ora");
      canvas.addEventListener("click", function() {
        location = "https://www.facebook.com/oramusicofficial/";
      });
      // document.body.appendChild(canvas);
      ctx = canvas.getContext("2d");

      canvas.width = this.sw * this.pixelRatio;
      canvas.height = this.sh * this.pixelRatio;
      canvas.style.width = this.sw + "px";
      canvas.style.height = this.sh + "px";
      ctx.scale(this.pixelRatio, this.pixelRatio);
      const texts = ["O.", "R.", "A."];
      for (var i = 0; i < 3; i++) {
        leons.push(
          new LeonSans({
            text: texts[i],
            color: ["#000000"],
            size: 80,
            weight: 200
            //   isWave: false,
            //   pathGap: 0.3,
            //   amplitude: 0.5,
            //   fps: 30
          })
        );
      }
      for (i = 0; i < 3; i++) {
        let j,
          total = leons[0].drawing.length;
        for (j = 0; j < total; j++) {
          TweenMax.fromTo(
            leons[i].drawing[j],
            2.5,
            {
              value: 0
            },
            {
              delay: j * 0.005,
              value: 1,
              ease: Power4.easeOut
            }
          );
        }
      }

      requestAnimationFrame(this.animate);
    },
    animate(t) {
      requestAnimationFrame(this.animate);

      ctx.clearRect(0, 0, this.sw, this.sh);

      // leon.weight = Math.abs(Math.sin(t / 500) * 900);
      // leon.pathGap = Math.abs(Math.cos(t / 500));
      for (var i = 0; i < leons.length; i++) {
        const x = (this.sw - leons[i].rect.w) / 4 + i * 80;
        const y = (this.sh - leons[i].rect.h) / 2;
        //   console.log((i + 3) % 3);
        if (t > 2500) {
          leons[i].weight = Math.abs(Math.sin(t / trand[2 - i]) * 200);
          leons[i].size = Math.abs(Math.cos(t / trand[i]) * 5) + 75;
        }

        //console.log(Math.abs(Math.sin(t / trand[i]) * 100));
        leons[i].position(x, y);
        leons[i].draw(ctx, t);
      }
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;

  canvas:hover {
    cursor: pointer;
  }
}
</style>
